import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20.828 14.357A8.25 8.25 0 0 1 9.161 2.689Zm.531-9.016a2.25 2.25 0 1 1 0-3.182 2.25 2.25 0 0 1 0 3.182m-3.182 0-3.182 3.182M3.25 22.522l4.243-4.242a1.5 1.5 0 0 1 2.121 0l4.243 4.242"
    }, null, -1)
  ]));
}
const interfaceShareSatellite = { render };
export {
  interfaceShareSatellite as default,
  render
};
//# sourceMappingURL=interface-share-satellite.svg.js.map
